import PageContentLoading from '../../PageContentLoading';
import { useInvitationPageContext } from './Contexts/InvitationPageContext';
import InviteCandidateContent from './InviteCandidateContent';
import InviteCandidatesPageHeader from './InviteCandidatesPageHeader';
import TopBar from '@/Components/TopBars/TopBar';
import Page from '@/Pages/Page';

function AttractCandidatesPageContent() {
    const { specsLoading, jobAdIdLoading } = useInvitationPageContext();

    return (
        <Page topBar={<TopBar />}>
            <InviteCandidatesPageHeader />
            <div className="flex flex-1 flex-col">
                <PageContentLoading isLoading={specsLoading || jobAdIdLoading} loadingFailed={false}>
                    <InviteCandidateContent />
                </PageContentLoading>
            </div>
        </Page>
    );
}

export default AttractCandidatesPageContent;
